var TemplateLibraryTemplateView = require( 'kitbuilder-templates/views/template/base' ),
	TemplateLibraryTemplateRemoteView;

TemplateLibraryTemplateRemoteView = TemplateLibraryTemplateView.extend( {
	template: '#tmpl-kitbuilder-template-library-template-remote',

	onPreviewButtonClick: function() {
		kitbuilder.templates.getLayout().showPreviewView( this.model );
	}
} );

module.exports = TemplateLibraryTemplateRemoteView;
